import type * as Types from '../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ResetPasswordEmailMutationVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
}>;


export type ResetPasswordEmailMutationPage = { readonly __typename?: 'RootMutationType', readonly resetPasswordEmail: boolean };


export const ResetPasswordEmailDocument = gql`
    mutation ResetPasswordEmail($email: String!) {
  resetPasswordEmail(email: $email)
}
    `;
export type ResetPasswordEmailMutationFn = Apollo.MutationFunction<ResetPasswordEmailMutationPage, ResetPasswordEmailMutationVariables>;

/**
 * __useResetPasswordEmailMutation__
 *
 * To run a mutation, you first call `useResetPasswordEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordEmailMutation, { data, loading, error }] = useResetPasswordEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResetPasswordEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordEmailMutationPage, ResetPasswordEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordEmailMutationPage, ResetPasswordEmailMutationVariables>(ResetPasswordEmailDocument, options);
      }
export type ResetPasswordEmailMutationHookResult = ReturnType<typeof useResetPasswordEmailMutation>;
export type ResetPasswordEmailMutationResult = Apollo.MutationResult<ResetPasswordEmailMutationPage>;
export type ResetPasswordEmailMutationOptions = Apollo.BaseMutationOptions<ResetPasswordEmailMutationPage, ResetPasswordEmailMutationVariables>;